/*!
This file is part of CycloneDX JavaScript Library.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

SPDX-License-Identifier: Apache-2.0
Copyright (c) OWASP Foundation. All Rights Reserved.
*/

export * from './index.common'

// region web-specifics

export * as Contrib from './contrib/index.web'
/** @deprecated next */
export * as Factories from './factories/index.web'
export * as Serialize from './serialize/index.web'
/** @deprecated next */
export * as Utils from './utils/index.web'
export * as Validation from './validation/index.web'

// endregion web-specifics

// do not export the _helpers, they are for internal use only

